(() => {
  if (location.pathname !== '/') return;

  const loader = document.currentScript;
  const logoUrl = loader?.dataset.logoUrl;
  if (!logoUrl) return;

  const applyLogo = (root = document) => {
    root.querySelectorAll('.header__heading-logo').forEach((logo) => {
      if (logo.dataset.customSharpLogo === 'true') return;
      logo.srcset = `${logoUrl} 1256w`;
      logo.src = logoUrl;
      logo.dataset.customSharpLogo = 'true';
    });
  };

  applyLogo();
  document.addEventListener('shopify:section:load', (event) => applyLogo(event.target));
})();
